module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intersecting-circles-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinnerBlock",
    style: (_vm.spinnerBlockStyle)
  }, _vm._l((_vm.circleStyles), function(cs, index) {
    return _c('span', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22411fbb!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/IntersectingCirclesSpinner.vue
// module id = 962
// module chunks = 1